// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"29e71bd0","455":"e287e6e6","977":"85635eb5"}[chunkId] + ".chunk.js";
};